import React from 'react';
import { Box, Container, Fab, Typography } from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import { makeStyles } from '@material-ui/styles';

const useStyle = makeStyles(() => {
  return {
    info: {
      padding: 16,
    },
    contact: {
      backgroundColor: '#272a34',
      color: '#fff',
      padding: 16,
    },
    icon: {
      color: "#fff"
    },
    fab: {
      backgroundColor: "#202229 ",
      marginRight: 16,
      "&:hover": {
        backgroundColor: "#262729"
      }
    },
    text: {
      color: '#666666',
      marginLeft: 10,
    },
    title: {
      textAlign: 'center'
    }
  }
});
const ContactUs = () => {
  const classes = useStyle();
  return (
    <Box display="flex">
      <Container className={classes.info} maxWidth="xs">
        <Typography variant="h5" className={classes.title}>Contact Us</Typography>
        <Box display='flex' alignItems="center" my={5}>
          <Box>
            <Fab className={classes.fab}>
              <EmailIcon className={classes.icon} />
            </Fab>
          </Box>
          <Typography>Email:</Typography>
          <Box width={10}>
            <Typography className={classes.text}>
              admin@mizbans.com
              support@mizbans.com
            </Typography>
          </Box>
        </Box>
        <Box display='flex' alignItems="center">
          <Box>
            <Fab className={classes.fab}>
              <PhoneIcon className={classes.icon} />
            </Fab>
          </Box>
          <Typography>Phone:</Typography>
          <Typography className={classes.text}>07132339577</Typography>
        </Box>
        <Box display='flex' alignItems="center" mt={5}>
          <Box>
            <Fab className={classes.fab} disableRipple>
              <LocationOnIcon className={classes.icon} />
            </Fab>
          </Box>
          <Typography>address:</Typography>
          <Box >
            <Typography className={classes.text} noWrap>
              Mizban office<br />
              5th floor, Tara APT, Haft Tir St<br/>
              Fars, Shiraz
              Iran
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default ContactUs
